/**
 * ADR-0155 — the Microsoft 365 kind's create sub-form. There are no fields:
 * the connection is established by the customer's Microsoft admin consenting
 * (via the consent package on the detail page), not by entering credentials.
 */

import type { IntegrationFormProps } from "./types.js";

export function MicrosoftIntegrationForm(_props: IntegrationFormProps): JSX.Element {
  return (
    <div className="help">
      Nothing to enter here. After creating the connection, use <strong>Get consent package</strong> on its page to
      send your Microsoft 365 administrator everything they need to approve access.
    </div>
  );
}
